import * as React from 'react';
import { Slot } from '@radix-ui/react-slot';
import { type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';
import type { PermissionCode } from '@/constants/permissions';
import { buttonVariants } from './variants';
import { VerifyGrantWrapper } from '@/components/VerifyGrantWrapper';

function Button({
  className,
  variant = 'default',
  size = 'default',
  asChild = false,
  grant,
  ...props
}: React.ComponentProps<'button'> &
  VariantProps<typeof buttonVariants> & {
    asChild?: boolean;
    /**
     * 权限码，传入后会判断用户是否有该权限，没有则不渲染
     */
    grant?: PermissionCode;
  }) {
  const Comp = asChild ? Slot : 'button';

  return (
    <VerifyGrantWrapper grant={grant}>
      <Comp
        type="button"
        data-slot="button"
        data-variant={variant}
        data-size={size}
        className={cn(buttonVariants({ variant, size, className }), 'cursor-pointer')}
        {...props}
      />
    </VerifyGrantWrapper>
  );
}

export { Button };
